import { setAutoFreeze } from "immer";

setAutoFreeze(false);

export * from "./lib";
